import { useEffectOnce } from '@carvana/merch-react-hooks';
import cx from 'classnames';
import dynamic from 'next/dynamic';
import PageFooter from '@/common/PageFooter';
import { isTest } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useConfiguration } from '~/context/common/StaticContext';
import Header from './Header';
import Hero from './Hero';
import ShaqbotChatMfe from './ShaqbotChatMfe';
import ShaqbotSection from './ShaqbotSection';
import ShaqsFavorites from './ShaqsFavorites';
import styles from './ShaqvanaContainer.module.css';
import VideosSection from './VideosSection';

const FeatureBranch = dynamic(
  () =>
    import(/* webpackChunkName: "FeatureBranch" */ '@/common/FeatureBranch'),
  { ssr: false }
);

export default function ShaqvanaContainer() {
  const trackEvent = useTrackEvent();
  const { showShaqvanaVideosSection } = useConfiguration();

  useEffectOnce(() => {
    trackEvent('carvana-page-load');
  }, [trackEvent]);

  return (
    <div className="bg-background-strong">
      {isTest && <FeatureBranch className="max-w-[1440px]" />}
      <div className={cx('mx-auto max-w-[1440px]', styles.container)}>
        <Header />
        <Hero />
        <ShaqbotSection />
        <ShaqsFavorites />
        <ShaqbotChatMfe />
        {showShaqvanaVideosSection && <VideosSection />}
        <PageFooter />
      </div>
    </div>
  );
}
